import React, { useEffect } from "react";
import ChatBotSelect from "../../features/SelectChatBot/components/ChatBotSelect";

const InitPage = () => {
  useEffect(() => {
    localStorage.removeItem("fromLanding");
  }, []);

  return <ChatBotSelect />;
};

export default InitPage;
